import { env } from '@/env';
import { NotificationId, NotificationStatus, type Notification } from '@/modules/api/codegen';
import { authUser } from '@/modules/auth/services/selectors/auth';
import { SubscriptionType } from '@/modules/settings/constants';
import { selectGeneralSettings } from '@/modules/settings/services/selectors';
import { getStore } from '@/services/context';

export const hasEnteredReviewPrizepool = (notification?: Notification) => notification?.status === NotificationStatus.resolved;

export const isEligibleForReviewPrizepool = async () => {
    if (env.VITE_DEMO) {
        return false;
    }

    const store = await getStore();
    const state = store.getState();

    const user = authUser(state);

    if (!user || hasEnteredReviewPrizepool(user.notifications.find(({ id }) => id === NotificationId.reviewPrizepool))) {
        return false;
    }

    const { subscription } = selectGeneralSettings(state);

    return subscription === SubscriptionType.free;
};
